<template>
  <div class="layer-list">
    <div class="layer-list__header mb-3" v-if="title || description">
      <div class="layer-list__header-left">
        <h3 v-if="title" class="mb-0">
          {{ title }}
        </h3>
        <p class="mt-2" v-if="description">{{ description }}</p>
      </div>
    </div>
    <v-skeleton-loader v-if="status === 'loading'" type="list-item, list-item, list-item"></v-skeleton-loader>
    <div v-if="status === 'success'" class="layer-list__controls">
      <v-checkbox
        class="layer-list__checkbox"
        v-if="toggleAllIsShown"
        v-model="allChecked"
        :indeterminate="allChecked === undefined"
        color="primary"
        hide-details
      >
        <template slot="label">
          <div class="layer-list__checkbox-label">
            {{ $t('product.allLayers') }}
          </div>
        </template>
      </v-checkbox>

      <template v-for="layer in itemsFormatted">
        <slot
          name="layer-item"
          :layer="layer"
          :value="innerValue"
          :set-active-layer="setActiveLayer"
          :reset-active-layer="resetActiveLayer"
          :update-value="updateValue"
        >
          <LayerListItem
            v-if="layer.featureCount !== 0"
            :layer="layer"
            v-model="innerValue"
            :disabled="disabled"
            :readonly="readonly"
            :cheap-value="layer.featureCount ? 'featureCount' : 'type'"
          ></LayerListItem>
        </slot>
      </template>
    </div>
    <v-alert v-if="status === 'failure'" color="error" text v-html="$t('product.layersFailed')"> </v-alert>
    <slot name="append" :active-layer="activeLayer"></slot>
  </div>
</template>

<script>
import LayerListItem from './LayerListItem.vue';

export default {
  name: 'layer-list',
  components: { LayerListItem },
  props: {
    items: {
      type: Array,
      required: true,
    },
    value: {
      type: Array,
    },
    title: {
      type: String,
    },
    description: {
      type: String,
    },
    attributesLink: {
      type: String,
      default: '#',
    },
    toggleAllIsShown: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    status: {
      type: String,
      default: 'iddle',
    },
  },
  data() {
    return {
      isLayerDemoShown: false,
      activeLayer: undefined,
    };
  },
  computed: {
    innerValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.updateValue(newValue);
      },
    },
    allChecked: {
      get() {
        if (this.innerValue.length === this.items.length) {
          return true;
        }
        if (this.innerValue.length === 0) {
          return false;
        }
        return undefined;
      },
      set(val) {
        this.innerValue = val ? this.items.map((x) => x.id) : [];
      },
    },
    itemsFormatted() {
      return [...this.items].sort((a, b) => {
        const aName = a.name.toLowerCase();
        const bName = b.name.toLowerCase();
        if (aName < bName) return -1;
        if (aName > bName) return 1;
        return 0;
      });
    },
  },
  mounted() {
    this.$emit('mounted');
  },
  methods: {
    setActiveLayer(layer) {
      this.activeLayer = layer;
    },
    resetActiveLayer() {
      this.activeLayer = undefined;
    },
    updateValue(newValue) {
      this.$emit('input', newValue);
    },
  },
};
</script>

<style lang="scss" scoped>
.layer-list {
  &__controls {
    margin-left: -6px;
    margin-right: -6px;
  }

  &__item {
    width: 100%;
    display: flex;
  }

  &__header {
    display: flex;
    justify-content: space-between;
    overflow: hidden;
  }

  &__header-counter {
    font-size: 20px;
    font-weight: normal;
  }

  &__attr-link {
    display: inline-block;
    margin-top: 6px;
  }

  &__checkbox {
    width: 100%;
    margin-top: 4px;
    padding: 4px 2px 4px 6px;
  }

  &__checkbox-label {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    color: #212121;
  }
}
</style>
